import { render } from "./NewTarget.vue?vue&type=template&id=3685ced1"
import script from "./NewTarget.vue?vue&type=script&lang=ts"
export * from "./NewTarget.vue?vue&type=script&lang=ts"
script.render = render

export default script